import {NoteState} from "./NoteState";
import {Action, handleActions} from "redux-actions";
import {
	INVOICE_NOTE_CREATED,
	INVOICE_NOTE_DELETED,
	INVOICE_NOTE_UPDATED,
	INVOICE_NOTES_FETCHED,
	JOB_NOTE_CREATED,
	JOB_NOTE_DELETED,
	JOB_NOTE_REMINDER_ADDED,
	JOB_NOTE_UPDATED,
	JOB_NOTES_FETCHED,
	NOTE_CREATED,
	NOTE_DELETED,
	NOTE_REMINDER_ADDED,
	NOTE_UPDATED,
	NOTES_FETCHED
} from "../../action/note/actionType";
import {isNullOrUndefined} from "util";
import Note from "../../../model/note/Note";
import {option} from "ts-option";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import {isDefined} from "../../../utils/Utils";

const initState: NoteState = {
	notes: {}, jobNotes: {}, invoiceNotes: {}
};

const reducer = handleActions({
	[NOTES_FETCHED]: (state: NoteState, action: Action<any>): NoteState => {
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.notes).forEach(key => {
			if (key != action.payload.leadId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.leadId] = action.payload.notes;
		return {...state, notes: notes}
	},
	[NOTE_CREATED]: (state: NoteState, action: Action<NOTE_CREATED>): NoteState => {
		let notesList = state.notes[action.payload.leadId];
		if (isNullOrUndefined(notesList)) {
			notesList = [action.payload.note];
		}
		else {
			notesList = notesList.concat(action.payload.note);
		}
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.notes).forEach(key => {
			if (key != action.payload.leadId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.leadId] = notesList;

		return {...state, notes: notes}
	},
	[NOTE_UPDATED]: (state: NoteState, action: Action<NOTE_UPDATED>): NoteState => {
		let notesList = state.notes[action.payload.leadId];
		if (isNullOrUndefined(notesList)) {
			notesList = [action.payload.note]
		}
		else {
			notesList = notesList.map(c => c.id == action.payload.note.id ? action.payload.note : c);
		}
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.notes).forEach(key => {
			if (key != action.payload.leadId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.leadId] = notesList;

		return {...state, notes: notes}
	},
	[NOTE_DELETED]: (state: NoteState, action: Action<NOTE_DELETED>): NoteState => {
		let notesList = state.notes[action.payload.leadId];
		if (isNullOrUndefined(notesList)) {
			notesList = [];
		}
		else {
			notesList = notesList.filter(c => c.id != action.payload.noteId);
		}
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.notes).forEach(key => {
			if (key != action.payload.leadId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.leadId] = notesList;

		return {...state, notes: notes}
	},
	[NOTE_REMINDER_ADDED]: (state: NoteState, action: Action<NOTE_REMINDER_ADDED>): NoteState => {
		let notesList = state.notes[action.payload.leadId];
		if (isNullOrUndefined(notesList)) {
			notesList = [];
		}
		else {
			notesList = notesList.map(
				c => c.id == action.payload.noteId ? c.copy({reminder: option(action.payload.reminderDate)}) : c);
		}
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.notes).forEach(key => {
			if (key != action.payload.leadId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.leadId] = notesList;

		return {...state, notes: notes}
	},
	[JOB_NOTES_FETCHED]: (state: NoteState, action: Action<JOB_NOTES_FETCHED>): NoteState => {
		const jobNotes: { [key: string]: Note[] } = {};
		Object.keys(state.jobNotes).forEach(key => {
			if (key != action.payload.jobId)
				jobNotes[key] = state.jobNotes[key];
		});
		jobNotes[action.payload.jobId] = action.payload.notes;
		return {...state, jobNotes: jobNotes}
	},
	[JOB_NOTE_CREATED]: (state: NoteState, action: Action<JOB_NOTE_CREATED>): NoteState => {
		let jobNotesList = state.jobNotes[action.payload.jobId];
		if (isNullOrUndefined(jobNotesList)) {
			jobNotesList = [action.payload.note];
		}
		else {
			jobNotesList = jobNotesList.concat(action.payload.note);
		}
		const jobNotes: { [key: string]: Note[] } = {};
		Object.keys(state.jobNotes).forEach(key => {
			if (key != action.payload.jobId)
				jobNotes[key] = state.jobNotes[key];
		});
		jobNotes[action.payload.jobId] = jobNotesList;

		return {...state, jobNotes: jobNotes}
	},
	[JOB_NOTE_UPDATED]: (state: NoteState, action: Action<JOB_NOTE_UPDATED>): NoteState => {
		let jobNotesList = state.jobNotes[action.payload.jobId];
		if (isNullOrUndefined(jobNotesList)) {
			jobNotesList = [action.payload.note]
		}
		else {
			jobNotesList = jobNotesList.map(c => c.id == action.payload.note.id ? action.payload.note : c);
		}
		const jobNotes: { [key: string]: Note[] } = {};
		Object.keys(state.jobNotes).forEach(key => {
			if (key != action.payload.jobId)
				jobNotes[key] = state.jobNotes[key];
		});
		jobNotes[action.payload.jobId] = jobNotesList;

		return {...state, jobNotes: jobNotes}
	},
	[JOB_NOTE_DELETED]: (state: NoteState, action: Action<JOB_NOTE_DELETED>): NoteState => {
		let jobNotesList = state.jobNotes[action.payload.jobId];
		if (isNullOrUndefined(jobNotesList)) {
			jobNotesList = [];
		}
		else {
			jobNotesList = jobNotesList.filter(c => c.id != action.payload.noteId);
		}
		const jobNotes: { [key: string]: Note[] } = {};
		Object.keys(state.jobNotes).forEach(key => {
			if (key != action.payload.jobId)
				jobNotes[key] = state.jobNotes[key];
		});
		jobNotes[action.payload.jobId] = jobNotesList;

		return {...state, jobNotes: jobNotes}
	},
	[JOB_NOTE_REMINDER_ADDED]: (state: NoteState, action: Action<JOB_NOTE_REMINDER_ADDED>): NoteState => {
		let notesList = state.jobNotes[action.payload.jobId];
		if (isNullOrUndefined(notesList)) {
			notesList = [];
		}
		else {
			notesList = notesList.map(
				c => c.id == action.payload.noteId ? c.copy({reminder: option(action.payload.reminderDate)}) : c);
		}
		const notes: { [key: string]: Note[] } = {};
		Object.keys(state.jobNotes).forEach(key => {
			if (key != action.payload.jobId)
				notes[key] = state.notes[key];
		});
		notes[action.payload.jobId] = notesList;

		return {...state, jobNotes: notes}
	},
	[INVOICE_NOTES_FETCHED]: (state: NoteState, action: Action<INVOICE_NOTES_FETCHED>): NoteState => {
		const invoiceNotes = {...state.invoiceNotes, [action.payload.invoiceId]: action.payload.notes};
		return {...state, invoiceNotes};
	},
	[INVOICE_NOTE_CREATED]: (state: NoteState, action: Action<INVOICE_NOTE_CREATED>): NoteState => {
		let invoiceNotesList = state.invoiceNotes[action.payload.invoiceId];
		if (!isDefined(invoiceNotesList)) {
			invoiceNotesList = [action.payload.note];
		}
		else {
			invoiceNotesList = invoiceNotesList.concat(action.payload.note);
		}
		const invoiceNotes = {...state.invoiceNotes, [action.payload.invoiceId]: invoiceNotesList};
		return {...state, invoiceNotes};
	},
	[INVOICE_NOTE_UPDATED]: (state: NoteState, action: Action<INVOICE_NOTE_UPDATED>): NoteState => {
		let invoiceNotesList = state.invoiceNotes[action.payload.invoiceId];
		if (!isDefined(invoiceNotesList)) {
			invoiceNotesList = [action.payload.note]
		}
		else {
			invoiceNotesList = invoiceNotesList.map(c => c.id == action.payload.note.id ? action.payload.note : c);
		}
		const invoiceNotes = {...state.invoiceNotes, [action.payload.invoiceId]: invoiceNotesList};
		return {...state, invoiceNotes};
	},
	[INVOICE_NOTE_DELETED]: (state: NoteState, action: Action<INVOICE_NOTE_DELETED>): NoteState => {
		let invoiceNotesList = state.invoiceNotes[action.payload.invoiceId];
		if (!isDefined(invoiceNotesList)) {
			invoiceNotesList = [];
		}
		else {
			invoiceNotesList = invoiceNotesList.filter(c => c.id != action.payload.noteId);
		}
		const invoiceNotes = {...state.invoiceNotes, [action.payload.invoiceId]: invoiceNotesList};
		return {...state, invoiceNotes};
	},
}, initState);

export default reducer;
